module.exports = __webpack_public_path__ + "8528a5484326b3eef06b6dfcc6ce25bd.svg";